export const SAVE_ALL_PASSENGERS = 'SAVE_ALL_PASSENGERS'